<template>
  <div>
    <p>
      <a
        v-ga="$ga.commands.trackOutbound.bind(this, 'https://www.instagram.com/planetpropaganda')"
        class="inline-flex my-4 no-underline"
        target="_blank"
        rel="noopener"
        href="https://www.instagram.com/planetpropaganda"
      >
        <button class="Button Button--secondary max-w-none flex items-center">
          <svg svg-inline="" class="fill-current w-4 h-6 md:w-6 md:h-6 mr-3" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 503.8 503.8"><path d="M252 45.4c67.2 0 75.1.3 101.7 1.5 24.6 1 38 5.2 46.8 8.6a78 78 0 0 1 29 18.9 78 78 0 0 1 18.9 29c3.4 8.9 7.5 22.2 8.6 46.8 1.2 26.5 1.5 34.5 1.5 101.8s-.3 75.2-1.5 101.8a139.4 139.4 0 0 1-8.6 46.7 83.5 83.5 0 0 1-47.9 47.8c-8.8 3.5-22.2 7.6-46.7 8.7-26.6 1.2-34.6 1.5-101.8 1.5s-75.3-.3-101.8-1.5a139.4 139.4 0 0 1-46.8-8.7 78 78 0 0 1-29-18.8 78 78 0 0 1-18.9-29c-3.4-8.9-7.5-22.2-8.6-46.8-1.3-26.6-1.5-34.5-1.5-101.8s.2-75.2 1.5-101.8c1-24.5 5.2-37.9 8.6-46.8a78 78 0 0 1 18.9-29 78 78 0 0 1 29-18.8c8.9-3.5 22.2-7.6 46.8-8.7A1750 1750 0 0 1 252 45.3M252 0c-68.5 0-77 .2-104 1.5S103 7 87 13.2a123.5 123.5 0 0 0-44.6 29 123.5 123.5 0 0 0-29 44.7c-6.3 16-10.6 34.3-11.8 61.2S0 183.5 0 251.9s.3 77 1.5 103.9 5.5 45.1 11.7 61.1a123.5 123.5 0 0 0 29 44.7 123.7 123.7 0 0 0 44.7 29c16 6.2 34.3 10.5 61.1 11.7s35.5 1.5 104 1.5 77-.3 103.8-1.5 45.1-5.5 61.1-11.7a128.8 128.8 0 0 0 73.7-73.7c6.2-16 10.5-34.3 11.7-61.1s1.5-35.5 1.5-103.9-.3-77-1.5-103.8-5.5-45.2-11.7-61.2a123.7 123.7 0 0 0-29-44.6 123.5 123.5 0 0 0-44.7-29C401 7 382.6 2.7 355.8 1.5S320.3 0 251.9 0z"/><path d="M252 122.6a129.4 129.4 0 1 0 129.3 129.3 129.3 129.3 0 0 0-129.4-129.3zm0 213.3a84 84 0 1 1 84-84 84 84 0 0 1-84 84z"/><circle cx="386.4" cy="117.4" r="30.2"/></svg>
          <span class="inline-block leading-tight flex-1">
            See Krampus’ responses
          </span>
        </Button>
      </a>
    </p>
    <p>
      <small>
        In the mood for punishment? Read the giveaway’s <button
          class="appearance-none underline text-gold-light hover:text-gold-lightest
          uppercase font-bold tracking-wider text-sm md:text-base"
          @click="openTerms"
        >
          Terms &amp; Conditions
        </button>.
      </small>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    openTerms() {
      const event = new Event('openterms', { bubbles: true });
      try {
        this.$el.dispatchEvent(event);
      } catch (e) {
        // handle IE not supporting Event constructor
        const legacyEvent = document.createEvent('Event');
        legacyEvent.initEvent('openterms', true, false);
        this.$el.dispatchEvent(legacyEvent);
      }
    },
  },
};
</script>
